import React from 'react';
import {Backdrop, Fade, IconButton, Modal} from "@mui/material";
import {makeStyles} from "@mui/styles";
import InquiryForm from "./InquiryForm";
import {Clear} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
        // overflow: 'auto'
    },
    paper: {
        // maxHeight:800,
        // overflow: 'auto',
        height:700,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    closeBtnContainer: {
        position: 'relative'
    },
    closeBtn: {
        position: 'absolute',
        right: '0'
    }
}));
const MoreInfoModal = ({inquiryModal,closeInquiryModal,inquiryData,setInquiry,submitInquiry,trip,selectedRooms}) => {
    const classes = useStyles();

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={inquiryModal}
            onClose={closeInquiryModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={inquiryModal}>
                <div className={classes.paper}>
                    <div className={classes.closeBtnContainer}>
                        <IconButton className={classes.closeBtn} aria-label="delete" size="medium" onClick={closeInquiryModal}>
                            <Clear />
                        </IconButton>
                    </div>
                    <h3 style={{margin:'10px',marginLeft:0}} id="transition-modal-title">Inquire Now</h3>
                    <p id="transition-modal-description">Looking for spaces, full or half charter, or more information?<br/>
                        Let us know and we will get back to you.
                    </p>
                    <InquiryForm setInquiry={setInquiry} inquiryData={inquiryData} submitInquiry={submitInquiry} trip={trip} selectedRooms={selectedRooms}/>
                </div>
            </Fade>
        </Modal>
    );
};

export default MoreInfoModal;